const vars = {
    desktopPageSize: 9,
    tabletPageSize: 8,
    mobilePageSize:4,
};
export default vars;